<template>
  <router-view></router-view>
</template>


<script setup>
import { useStore } from "vuex";
const store = useStore();

window.addEventListener("resize", ()=>{
  store.commit("SET_WINDOW_WIDTH", window.innerWidth)
});

</script>
